/*
 CallMeManager Module

 */


const CallMeManager = (function() {
    // ================== VARIABLE ================== //
    //var _fields = ['email', 'mobile', 'destination', 'c_type', 'departure_date', 'duration', 'is_catamaran', 'style', 'sharing'];
    //var _fields = ['email', 'mobile', 'destination', 'c_type', 'departure_date', 'duration', 'is_catamaran', 'style', 'sharing'];
    var _url;

    // ================== CONSTRUCTOR ================== //
    function CallMeManager() {
        // Singleton
        if (CallMeManager.instance) {
            throw new Error('CallMeManager is a singleton. Use CallMeManager.instance.');
        }
        // enforces new
        if (!(this instanceof CallMeManager)) {
            return new CallMeManager();
        }
    };

    // ================== PUBLIC METHOD ================== //
    CallMeManager.prototype.init = function(url) {
        _url = url;
        $('#no-result-submit').on('click', function(e) {
            e.preventDefault();
            if($('#no-result-email').val() != '' || $('#no-result-mobile').val() != '') {
              _postForm();            
            }
        })
    };

    CallMeManager.prototype.reset = function(url) {
        $("#success-response").hide();
        $("#subscribe-form").show();
    };

    // ================== PRIVATE METHOD ================== //
    function _postForm() {
        $.ajax({
            url: _url,
            method: 'POST',
            data: _getFormData(),
            dataType: "json",
            error: _onError,
            success: _onSuccess,
        });
    };

    function _getFormData() {
        return $('#search-form').serialize();
    }

    function _onError(response, error) {
        console.error(error);
        console.error("Erreur : responseText: " + request.responseText);
    }

    function _onSuccess(response) {
        $("#success-response").show();
        $("#subscribe-form").hide();
    }

    CallMeManager.instance = new CallMeManager();

    return CallMeManager.instance;
})();

export default CallMeManager


// WEBPACK FOOTER //
// ./search/static/search/js/callMeManager.js